import React from 'react';
import { Button } from '@chakra-ui/react';
import { Share2 } from 'lucide-react';

interface ShareActionsProps {
  onShare: () => void;
  isLoading?: boolean;
}

/**
 * ShareActions - Share button that opens native share sheet
 */
export function ShareActions({ onShare, isLoading }: ShareActionsProps) {
  return (
    <Button
      w="100%"
      bg="purple.500"
      color="white"
      _hover={{ bg: 'purple.600' }}
      _active={{ bg: 'purple.700' }}
      leftIcon={<Share2 size={18} />}
      onClick={onShare}
      isLoading={isLoading}
      size="lg"
    >
      Share
    </Button>
  );
}
